import { getEndpoint, getHeaders } from '../../../helpers/endpoint';
import map from "lodash/map";

export const REQUEST_FETCH_STATS_MASTER_LEAGUES = 'REQUEST_FETCH_STATS_MASTER_LEAGUES';
export const SUCCESS_FETCH_STATS_MASTER_LEAGUES = 'SUCCESS_FETCH_STATS_MASTER_LEAGUES';
export const FAIL_FETCH_STATS_MASTER_LEAGUES = 'FAIL_FETCH_STATS_MASTER_LEAGUES';

export const fetchStatsMasterLeagues = (payload, onSuccess, onFail, onRequest) => {
    return (dispatch, getState) => {
        dispatch({ type: REQUEST_FETCH_STATS_MASTER_LEAGUES, payload });
        if (onRequest) onRequest(payload);

        fetch(getEndpoint('fetchStatsMasterLeagues', payload), {
            method: 'GET',
            headers: getHeaders(getState().authentication),
        })
            .then(response => response.json()).then(data => {
            if(data.error) dispatch({ type: FAIL_FETCH_STATS_MASTER_LEAGUES });
            else {
                const leagues = data.creations;
                const creations = map({ ...leagues }, (stat, key) => {
                    return { ...stat, id: `creations-${key}`, date: key }
                });

                dispatch({ type: SUCCESS_FETCH_STATS_MASTER_LEAGUES, data: { ...data, creations } });
            }

            if (onSuccess) onSuccess(data, payload);
        })
            .catch((error, type = FAIL_FETCH_STATS_MASTER_LEAGUES) => {
                if (onFail) onFail(type, error);
                dispatch({ type, error });
            });
    };
};

export const REQUEST_FETCH_STATS_MASTER_LEAGUES_BY_STATUS = 'REQUEST_FETCH_STATS_MASTER_LEAGUES_BY_STATUS';
export const SUCCESS_FETCH_STATS_MASTER_LEAGUES_BY_STATUS = 'SUCCESS_FETCH_STATS_MASTER_LEAGUES_BY_STATUS';
export const FAIL_FETCH_STATS_MASTER_LEAGUES_BY_STATUS = 'FAIL_FETCH_STATS_MASTER_LEAGUES_BY_STATUS';

export const fetchStatsMasterLeaguesByStatus = (payload, onSuccess, onFail, onRequest) => {
    return (dispatch, getState) => {
        dispatch({ type: REQUEST_FETCH_STATS_MASTER_LEAGUES_BY_STATUS, payload });
        if (onRequest) onRequest(payload);

        fetch(getEndpoint('fetchStatsMasterLeaguesByStatus', payload), {
            method: 'GET',
            headers: getHeaders(getState().authentication),
        })
            .then(response => response.json()).then(data => {
            if(data.error) dispatch({ type: FAIL_FETCH_STATS_MASTER_LEAGUES_BY_STATUS });
            else dispatch({ type: SUCCESS_FETCH_STATS_MASTER_LEAGUES_BY_STATUS, data });

            if (onSuccess) onSuccess(data, payload);
        })
            .catch((error, type = FAIL_FETCH_STATS_MASTER_LEAGUES_BY_STATUS) => {
                if (onFail) onFail(type, error);
                dispatch({ type, error });
            });
    };
};

export const REQUEST_FETCH_STATS_MASTER_LEAGUES_RESTART = 'REQUEST_FETCH_STATS_MASTER_LEAGUES_RESTART';
export const SUCCESS_FETCH_STATS_MASTER_LEAGUES_RESTART = 'SUCCESS_FETCH_STATS_MASTER_LEAGUES_RESTART';
export const FAIL_FETCH_STATS_MASTER_LEAGUES_RESTART = 'FAIL_FETCH_STATS_MASTER_LEAGUES_RESTART';

export const fetchStatsMasterLeaguesRestart = (payload, onSuccess, onFail, onRequest) => {
    return (dispatch, getState) => {
        dispatch({ type: REQUEST_FETCH_STATS_MASTER_LEAGUES_RESTART, payload });
        if (onRequest) onRequest(payload);

        fetch(getEndpoint('fetchStatsMasterLeaguesRestart', payload), {
            method: 'GET',
            headers: getHeaders(getState().authentication),
        })
            .then(response => response.json()).then(data => {
            if(data.error) dispatch({ type: FAIL_FETCH_STATS_MASTER_LEAGUES_RESTART });
            else dispatch({ type: SUCCESS_FETCH_STATS_MASTER_LEAGUES_RESTART, data });

            if (onSuccess) onSuccess(data, payload);
        })
            .catch((error, type = FAIL_FETCH_STATS_MASTER_LEAGUES_RESTART) => {
                if (onFail) onFail(type, error);
                dispatch({ type, error });
            });
    };
};



// WEBPACK FOOTER //
// ./src/actions/entities/statistics/masterLeague.js